import { NavTreeItem } from "../../../../components/common/navigation";
import { useTranslation } from "../../../../hooks/useTranslation";
import { UserRole } from "../../../../models/user.model";

const ALL_ROLES: UserRole[] = [UserRole.User, UserRole.Manager, UserRole.Admin];

// Static-content topic — no backend data, so this is a single leaf NavTreeItem
// with no children, same shape as the Certificates/Professional Summary topics.
export const useSearchFaqTree = (): NavTreeItem | null => {
    const { t } = useTranslation();

    return {
        id: "search",
        label: t("FAQ_TOPIC_SEARCH", undefined, "Search"),
        path: "search",
        requiredRoles: ALL_ROLES,
    };
};
